import {TMRJobStatus, TMRJob} from '@crema/services/apis/tmr';

// ---------------------------------------------------------------------------
// Action type string constants
// ---------------------------------------------------------------------------

export const TMR_UPLOAD_START = 'TMR_UPLOAD_START';
export const TMR_UPLOAD_SUCCESS = 'TMR_UPLOAD_SUCCESS';
export const TMR_UPLOAD_FAILURE = 'TMR_UPLOAD_FAILURE';

export const TMR_POLL_UPDATE = 'TMR_POLL_UPDATE';
export const TMR_POLL_STOP = 'TMR_POLL_STOP';

export const TMR_FETCH_HISTORY_START = 'TMR_FETCH_HISTORY_START';
export const TMR_FETCH_HISTORY_SUCCESS = 'TMR_FETCH_HISTORY_SUCCESS';
export const TMR_FETCH_HISTORY_FAILURE = 'TMR_FETCH_HISTORY_FAILURE';

export const TMR_CLEAR_CURRENT_JOB = 'TMR_CLEAR_CURRENT_JOB';

// ---------------------------------------------------------------------------
// Action interfaces
// ---------------------------------------------------------------------------

/** Fired when the upload request is sent (sets isUploading = true). */
export interface TMRUploadStartAction {
  type: typeof TMR_UPLOAD_START;
}

/** Fired when the backend returns the new job_id (upload succeeded). */
export interface TMRUploadSuccessAction {
  type: typeof TMR_UPLOAD_SUCCESS;
  payload: {
    jobId: number;
    status: string;
  };
}

/** Fired when the upload request fails. */
export interface TMRUploadFailureAction {
  type: typeof TMR_UPLOAD_FAILURE;
  error: string;
}

/** Fired on each polling tick with the latest job state from the API. */
export interface TMRPollUpdateAction {
  type: typeof TMR_POLL_UPDATE;
  payload: TMRJobStatus;
}

/** Fired to signal that active polling should cease. */
export interface TMRPollStopAction {
  type: typeof TMR_POLL_STOP;
}

/** Fired when the history-fetch request is sent. */
export interface TMRFetchHistoryStartAction {
  type: typeof TMR_FETCH_HISTORY_START;
}

/** Fired when the history list is successfully retrieved. */
export interface TMRFetchHistorySuccessAction {
  type: typeof TMR_FETCH_HISTORY_SUCCESS;
  payload: TMRJob[];
}

/** Fired when the history-fetch request fails. */
export interface TMRFetchHistoryFailureAction {
  type: typeof TMR_FETCH_HISTORY_FAILURE;
  error: string;
}

/** Fired to reset the current job so the user can start a new submission. */
export interface TMRClearCurrentJobAction {
  type: typeof TMR_CLEAR_CURRENT_JOB;
}

// ---------------------------------------------------------------------------
// Union type consumed by the reducer
// ---------------------------------------------------------------------------

export type TMRActions =
  | TMRUploadStartAction
  | TMRUploadSuccessAction
  | TMRUploadFailureAction
  | TMRPollUpdateAction
  | TMRPollStopAction
  | TMRFetchHistoryStartAction
  | TMRFetchHistorySuccessAction
  | TMRFetchHistoryFailureAction
  | TMRClearCurrentJobAction;
